window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.toastr = require('toastr');

    require('bootstrap');
    // require('bootstrap-switch/dist/js/bootstrap-switch');

    require('admin-lte');

    require( 'jquery.maskedinput/src/jquery.maskedinput');

    require( 'jquery-validation/dist/jquery.validate');
    require('jquery-validation/dist/additional-methods');
    require('jquery-ui-dist/jquery-ui.min');

    require( 'datatables.net/js/jquery.dataTables' );
    require( 'datatables.net-bs4' );
    require( 'datatables.net-buttons-bs4' );
    require( 'datatables.net-buttons/js/buttons.html5' );
    require( 'datatables.net-buttons/js/buttons.print' );
    require( 'datatables.net-buttons/js/buttons.colVis' );
    require( 'datatables.net-responsive-bs4' );
    require( 'datatables.net-colreorder-bs4' );
    require( 'datatables.net-rowreorder-bs4' );
    require( 'datatables.net-autofill-bs4' );
    // pdfMake
    // var pdfMake = require('pdfmake/build/pdfmake.js');
    // var pdfFonts = require('pdfmake/build/vfs_fonts.js');
    // pdfMake.vfs = pdfFonts.pdfMake.vfs;
    // window.JSZip = require( 'jszip' );

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
